import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Home';
import Bio from './Bio';
import Workshop from './Workshop';
import Shop from './Shop';
import Login from './Login';
import Ragister from './Ragister';
import Addproduct from './ADD/Addproduct';
import Addcategory from './ADD/AddCategory';
import Contact from './Contact';
import Cart from './Cart';
import SingleProduct from './VIEW/SingleProduct';
import Myaccount from './Myaccount';
// import Footer from './Footer';
import Checkout from './Checkout';
import Header from './Header';
import { CartProvider } from './CartContext';
import SinglepageFull from './SinglepageFull';
import { ToastContainer } from 'react-toastify';
import CollaborationForm from './CollaborationForm';
import Categoryview from './Categoryview';
import Mininav from './Mininav';
import Privacy from './Privacy';
import Terms from './Terms';
import Slidsmooth from './Slidsmooth';
import Gallery from './Gallery';
import ShoppingTerms from './ShoppingTerms';
import FAQ from './FAQ';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <ToastContainer />
    <BrowserRouter>
      <CartProvider>
        <Routes>
          <Route path='/' element={<Shop/>} />
          <Route path='/bio' element={<Bio />} />
          <Route path='/workshop' element={<Workshop />} />
          <Route path='/home' element={<Home/>} />
          <Route path='/login' element={<Login />} />
          <Route path='/Creteaccount' element={<Ragister />} />
          <Route path='/addproduct' element={<Addproduct />} />
          <Route path='/addcategory' element={<Addcategory />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/cart' element={<Cart />} />
          <Route path="/product/:id" element={<SingleProduct />} />
          <Route path="/myaccount" element={<Myaccount />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/productt/:id" element={<SinglepageFull />} />
          <Route path="/collaborationform" element={<CollaborationForm />} />
          <Route path="/categoryview" element={<Categoryview />} />
          <Route path="/mininav" element={<Mininav />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/shoppingterms"element={<ShoppingTerms/>}/>
          <Route path="/faq"element={<FAQ/>}/>
          {/* <Route path="/slidsmooth" element={<Slidsmooth />} /> */}
        </Routes>
      </CartProvider >
     {/* <Footer />  */}
    </BrowserRouter>

  </>
);
